const ArricchimentoStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "loiForm",
                description: "",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "internalLoiId",
                            type: "text",
                            numColMd: 6,
                            label: "ID-Loi",
                            tooltipText: "",
                            required: false,
                        },
                        {
                            name: "loiName",
                            type: "text",
                            numColMd: 6,
                            tooltipText: "",
                            label: "Line of Inquiry",
                            required: true,    
                        },
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "loiDemacoFileNumber",
                            type: "text",
                            numColMd: 12,
                            label: "Nota MAB - Demaco",
                            required: false,
                            tooltipText: "",
                        },
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "notaMabFileNet",
                            type: "text",
                            numColMd: 12,
                            label: "Nota MAB - Filenet",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "loiNote",
                            type: "textArea",
                            numColMd: 12,
                            label: "Nota - Line of Inquiry",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                }]
            }  
        }
    }
}

export default ArricchimentoStructure;